module.exports = __webpack_public_path__ + "static/img/19009C_2_3_R_09302019_fit.496900d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19009C_2_3_R_09302019_fit.png
// module id = w81K
// module chunks = 0